<template>
  <div class="cc-tool">
    <div class="cc-toolbar">
      <span class="cc-label">{{ $t('tool.CaseConverter.title') }}</span>
      <span class="cc-spacer"/>
      <el-button size="small" plain icon="el-icon-document-copy" @click="copyActive">{{ $t('tool.CaseConverter.copySelected') }}</el-button>
      <el-button size="small" plain icon="el-icon-delete" @click="clearAll">{{ $t("common.action.clear") }}</el-button>
    </div>
    <el-input v-model="input" type="textarea" :rows="6" :placeholder="$t('tool.CaseConverter.phInput')"
      class="cc-textarea" @input="convertAll"/>
    <div class="cc-status-bar" v-if="!input.trim()">
      <span class="cc-hint">{{ $t('tool.CaseConverter.hintEmpty') }}</span>
    </div>
    <div class="cc-grid" v-if="input.trim()">
      <div v-for="c in cases" :key="c.key" :class="['cc-card',{active:activeCase===c.key}]" @click="copyCard(c)">
        <div class="cc-card-hd">
          <span>{{ c.label }}</span>
          <span class="cc-card-badge" v-if="activeCase===c.key">{{ $t('tool.CaseConverter.copied') }}</span>
        </div>
        <code class="cc-card-val">{{ result[c.key] || '—' }}</code>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name:'CaseConverterTool',props:{config:{type:Object,default:()=>({})}},
  data:function(){
    return {
      input:'',result:{},activeCase:''
    }
  },
  computed:{
    types(){ return this.$t('tool.CaseConverter.types') },
    cases(){
      var t = this
      return Object.keys(this.types).map(function(key) {
        return { key: key, label: t.types[key] }
      })
    }
  },
  methods:{
    convertAll:function(){
      var t = this.input; this.activeCase = ''
      if (!t.trim()) { this.result = {}; return }
      this.result = {
        upper: t.toUpperCase(),
        lower: t.toLowerCase(),
        title: t.replace(/\w\S*/g,function(w){return w[0].toUpperCase()+w.slice(1).toLowerCase()}),
        camel: t.replace(/[-_\s]+(.)?/g,function(_,c){return c?c.toUpperCase():''}).replace(/^[A-Z]/,function(c){return c.toLowerCase()}),
        pascal: t.replace(/[-_\s]+(.)?/g,function(_,c){return c?c.toUpperCase():''}).replace(/^[a-z]/,function(c){return c.toUpperCase()}),
        snake: t.replace(/([a-z])([A-Z])/g,'$1_$2').replace(/[\s-]+/g,'_').toLowerCase(),
        kebab: t.replace(/([a-z])([A-Z])/g,'$1-$2').replace(/[\s_]+/g,'-').toLowerCase(),
        constant: t.replace(/([a-z])([A-Z])/g,'$1_$2').replace(/[\s-]+/g,'_').toUpperCase()
      }
    },
    copyCard:function(c){
      var val = this.result[c.key]
      if (!val) return
      navigator.clipboard.writeText(val).then(function(){
        this.activeCase = c.key
      }.bind(this))
    },
    copyActive:function(){
      if (this.activeCase && this.result[this.activeCase]) {
        navigator.clipboard.writeText(this.result[this.activeCase])
      } else {
        var keys = Object.keys(this.result)
        if (keys.length) { navigator.clipboard.writeText(this.result[keys[0]]) }
      }
    },
    clearAll:function(){ this.input = ''; this.result = {}; this.activeCase = '' },
    doAction:function(a){
      if (a === 'copy') this.copyActive()
      if (a === 'clear') this.clearAll()
    }
  }
}
</script>

<style scoped>
.cc-tool{display:flex;flex-direction:column;gap:12px;max-width:100%}

.cc-toolbar{display:flex;align-items:center;gap:8px;flex-wrap:wrap}
.cc-toolbar >>> .el-button + .el-button{margin-left:0}
.cc-label{font-size:13px;font-weight:700;color:#1a1f36;white-space:nowrap}
.cc-spacer{flex:1}

.cc-textarea >>> textarea{
  font-family:'JetBrains Mono','Fira Code','Consolas',monospace!important;
  font-size:13px!important;line-height:1.6!important;
  border-radius:10px;resize:vertical
}

.cc-status-bar{font-size:12px}
.cc-hint{color:#c0c4cc}

.cc-grid{display:grid;grid-template-columns:repeat(2,1fr);gap:10px}
.cc-card{background:#fff;border:1.5px solid #ebeef5;border-radius:10px;padding:14px 16px;cursor:pointer;transition:all .15s;position:relative}
.cc-card:hover{border-color:#4e7cff;box-shadow:0 2px 8px rgba(78,124,255,.06)}
.cc-card.active{border-color:#67c23a;background:#f6fef6}
.cc-card-hd{display:flex;align-items:center;justify-content:space-between;margin-bottom:6px}
.cc-card-hd span:first-child{font-size:11px;color:#909399;font-weight:600}
.cc-card-badge{font-size:10px;color:#67c23a;font-weight:600}
.cc-card-val{font-family:'SF Mono',Menlo,Consolas,monospace;font-size:14px;color:#303133;word-break:break-all;line-height:1.5}

@media(max-width:640px){
  .cc-grid{grid-template-columns:1fr}
}
</style>
